import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function Hero() {
  const scrollToOffer = () => {
    const offerSection = document.getElementById('offer');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <header className="relative min-h-screen w-full bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center px-4 py-16 overflow-hidden" data-id="element-20">
      {/* Animated background elements */}
      <div className="absolute inset-0 opacity-20" data-id="element-21">
        <div className="absolute top-20 left-10 w-72 h-72 bg-teal-500 rounded-full blur-3xl animate-pulse" data-id="element-22"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-gold-400 rounded-full blur-3xl animate-pulse" style={{
        animationDelay: '1s'
      }} data-id="element-23"></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-24">
        {/* Left: Text Content */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center lg:text-left" data-id="element-25">
          <motion.h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-26">
            ¿Sientes ese nudo en el estómago cada vez que revisas{' '}
            <span className="text-gold-400" data-id="element-27">el tipo de cambio</span> o{' '}
            <span className="text-gold-400" data-id="element-28">el precio de la gasolina</span>?
          </motion.h1>

          <motion.p className="text-xl md:text-2xl text-gray-300 mb-8 leading-relaxed" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} data-id="element-29">
            Esa sensación de que, por más que trabajes, siempre estás corriendo{' '}
            <span className="text-teal-400 font-semibold" data-id="element-30">
              un paso por detrás de la inflación
            </span>
            .
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.6
        }} data-id="element-31">
            <Button size="large" className="w-full lg:w-auto" onClick={scrollToOffer} data-id="element-32">
              Accede al Curso de Sueldo Digital
            </Button>
          </motion.div>
        </motion.div>

        {/* Right: Hero Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.3,
        ease: 'easeOut'
      }} className="flex justify-center" data-id="element-33">
          <img src="https://cdn.magicpatterns.com/uploads/i4c8DbQRHzx9ekDUNXFqv2/heylloyd-image-1771588933528.png" alt="Tablet mostrando El Código del Sueldo Digital en pantalla con fondo tecnológico" className="w-full max-w-lg rounded-lg shadow-2xl" data-id="element-34" />
        </motion.div>
      </div>
    </header>;
}